import MonetizableCapabilities from '../../components/MonetizableCapabilities/MonetizableCapabilities';
import React from 'react';
import HomeOneHeader from './HomeOneHeader/HomeOneHeader';
// import HomeHeroSlider from './HomeHeroArea/HomeHeroSlider';
// import HomeFeatures from './HomeFeatures/HomeFeatures';
import HomeAbout from './HomeAbout/HomeAbout';
import HomeCapabilities from './HomeCapabilities/HomeCapabilities';
// import HomeServices from './HomeServices/HomeServices';
// import HomeCounterArea from './HomeCounterArea/HomeCounterArea';
// import HomeTeams from './HomeTeams/HomeTeams';
// import HomePricing from './HomePricing/HomePricing';
import HomeBrands from './HomeBrands/HomeBrands';
// import HomeContact from './HomeContact/HomeContact';
import ContactArea from '../Contact/ContactArea/ContactArea';
import Footer from '../../components/shared/Footer';
import PlaybooksBanner from '../../components/Playbooks/PlaybooksBanner';
import AiAuditBanner from '../../components/AiAuditBanner/AiAuditBanner';
// import CommonCtaArea from '../../components/CommonCtaArea/CommonCtaArea';
import PageHelmet from '../../components/shared/PageHelmet';
import HomeTwoFeatures from '../HomeTwo/HomeTwoFeatures/HomeTwoFeatures';
import HomeSellingFaq from '../../components/HomeSellingFaq/HomeSellingFaq';
import DynamicValueMessage from '../../components/PlaybookStory/DynamicValueMessage';
import PlaybookScrollStory from '../../components/PlaybookStory/PlaybookScrollStory';
import HomeNewsletterPopup from '../../components/HomeNewsletterPopup/HomeNewsletterPopup';
import GoogleDataUse from '../../components/GoogleDataUse/GoogleDataUse';


import { useTranslation } from "react-i18next";
import CoreDetails from '../CorePrelaunch/Prelaunch/CoreDetails';




import HomeTwoBlogs from '../HomeTwo/HomeTwoBlogs/HomeTwoBlogs';
// import HomeTwoCaseArea from '../HomeTwo/HomeTwoCaseArea/HomeTwoCaseArea';
// import HomeTwoCounter from '../HomeTwo/HomeTwoCounter/HomeTwoCounter';
import HomeTwoExpertArea from '../HomeTwo/HomeTwoExpertArea/HomeTwoExpertArea';
// import TeamArea from '../Team/TeamArea/TeamArea';
import HomeThreeFaq from '../HomeThree/HomeThreeFaq/HomeThreeFaq';
import TechGridFloor from '../../components/TechGridFloor/TechGridFloor';
import { buildFaqSchema, buildEventSchema } from '../../lib/structuredData';
import WebinarSection from '../../components/WebinarBanner/WebinarSection';
import { businessLogic } from '../../lib/constants';
import {
  webinar,
  isWebinarVisible,
  isWebinarConfigured,
  getWebinarTitle,
  getWebinarTagline,
  getWebinarEndISO,
} from '../../lib/webinar';


const Home = () => {
  const { t, i18n } = useTranslation();
  const lang = i18n && i18n.language ? i18n.language : 'es';

  // Solo emitimos datos estructurados del webinar cuando está activo Y configurado
  // de verdad (no con la URL placeholder), para no publicar un Event falso.
  const webinarSchema =
    isWebinarVisible() && isWebinarConfigured()
      ? buildEventSchema({
          name: getWebinarTitle(lang),
          description: getWebinarTagline(lang),
          startDate: webinar.startsAt,
          endDate: getWebinarEndISO(),
          url: webinar.meetupUrl,
          image: businessLogic.ogImage,
        })
      : null;

  // FAQPage de la home: UN solo bloque con TODO lo que el visitante ve
  // realmente en pantalla, en el mismo orden en que aparece.
  //
  // Antes había un `faqSchema` de 3 preguntas que en realidad son las de la
  // página /faq (t("faq_q1..3")) y que en la home NUNCA se ven: Google
  // desaconseja marcar contenido que no está en la página ("no structured
  // data for invisible content"), así que quedaba mal etiquetado. También
  // había un segundo bloque FAQPage aparte para HomeSellingFaq; dos schemas
  // del mismo @type en una sola URL es ambiguo para quien los consume. Ahora
  // es uno solo que cubre HomeSellingFaq (8 preguntas) + el acordeón de
  // HomeThreeFaq (4 preguntas, que antes no tenía NINGÚN schema).
  const homeFaqSchema = buildFaqSchema([
    ...Array.from({ length: 8 }, (_, i) => {
      const n = i + 1;
      return {
        pregunta: t(`home_sell_faq_q${n}`),
        respuesta: t(`home_sell_faq_a${n}`),
      };
    }),
    ...Array.from({ length: 4 }, (_, i) => {
      const n = i + 1;
      return {
        pregunta: t(`home_faqs_questions_tileline_title_${n}`),
        respuesta: t(`home_faqs_questions_tileline_subtitle_${n}`),
      };
    }),
  ]);

    return (
        <>
            {/* pageTitle era "Home", que no dice nada y no lleva keyword. Ahora que la
                home SÍ se prerenderiza e indexa, el <title> es el activo on-page
                más valioso del dominio. */}
            <PageHelmet pageTitle={t('page_title_home')} description={t('page_meta_home')} structuredData={[homeFaqSchema, webinarSchema]} />
            <HomeOneHeader textColor="purple" logoVariant="purple" />
            <TechGridFloor />
            {/* Que vendemos, en pocos segundos: sistemas completos, no un builder */}
            <DynamicValueMessage />
            <AiAuditBanner />
            {/* <HomeHeroSlider /> */}

            <HomeTwoFeatures/>
            <HomeSellingFaq />
             {/* <IntegrationsArea/> */}

            <WebinarSection/>

            {/* El recorrido desemboca justo en el CTA de Playbooks que ya existia */}
            <PlaybookScrollStory />

            <PlaybooksBanner/>



            <MonetizableCapabilities />

            
            {/* <HomeFeatures /> */}

            
            <HomeAbout />
            <HomeCapabilities />
            {/* <HomeCounterArea/> */}
            {/* <HomeTeams/> */}

            <CoreDetails/>






            <HomeThreeFaq />

            
            {/* Catalogo duplicado: la seccion "Capacidades que puedes monetizar"
                de mas arriba ya pinta el catalogo, y el completo por categorias
                vive en /services. */}
            {/* <IntegrationsArea/> */}
            {/* <TeamArea/> */}


            {/* TABS AREA -> INTEGRATIONS, LEARNING, GAMIFICATION */}
            <HomeTwoExpertArea/>


            {/* <HomeTwoCounter/> */}



            {/* <HomeTwoCaseArea/> */}



            {/* NEWS AREA */}
            <HomeTwoBlogs/>






            {/* <CommonCtaArea/> */}
            {/* <HomeServices/> */}

            {/* <HomePricing/> */}

            {/* Verificación de Google: la home explica cómo se usa la cuenta de Google y
                enlaza /privacy. Texto en src/data/googleDataUse.js. */}
            <GoogleDataUse/>

            <HomeBrands/>
            {/* <HomeContact/> */}
            <ContactArea/>

            
            <Footer/>

            {/* Captación: alta en la newsletter (sin kit), que se abre sola al hacer
                scroll (una vez por sesión), cuando ya se ha leído el mensaje
                principal (section.dvm, de DynamicValueMessage). Manda a
                lead-magnet-html-form. */}
            <HomeNewsletterPopup after="section.dvm"/>


            {/* La barra de cookies es global (components/CookieBanner, montada en App.js). */}




        </>
    );
};

export default Home;
